import * as React from 'react'

const Deactivate = (props: { className: string }) => {
  return (
    <svg
      className={'icon' + props.className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='8' cy='8' r='7.5' stroke='#8C97A2' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.08401 7.85946L11.9024 5.02703C12.0325 4.8973 12.0325 4.7027 11.9024 4.57297L11.4688 4.11892C11.3388 3.98919 11.1436 3.98919 11.0136 4.11892L8.17344 6.95135C8.08672 7.03784 7.95664 7.03784 7.86992 6.95135L5.02981 4.0973C4.89973 3.96757 4.70461 3.96757 4.57453 4.0973L4.11924 4.55135C3.98916 4.68108 3.98916 4.87568 4.11924 5.00541L6.95935 7.83784C7.04607 7.92432 7.04607 8.05405 6.95935 8.14054L4.09756 10.9946C3.96748 11.1243 3.96748 11.3189 4.09756 11.4486L4.55285 11.9027C4.68293 12.0324 4.87805 12.0324 5.00813 11.9027L7.84824 9.07027C7.93496 8.98378 8.06504 8.98378 8.15176 9.07027L10.9919 11.9027C11.122 12.0324 11.3171 12.0324 11.4472 11.9027L11.9024 11.4486C12.0325 11.3189 12.0325 11.1243 11.9024 10.9946L9.08401 8.16216C8.99729 8.07568 8.99729 7.94595 9.08401 7.85946Z'
        fill='#8C97A2'
      />
    </svg>
  )
}

export default Deactivate



// WEBPACK FOOTER //
// ./src/components/icons/vehicle/Deactivate.tsx